$('form').on('submit', function (event) {
    event.preventDefault();
});
//Validar que el formulario de asesoría tenga un valor correcto en espacio a decorar si no muestra mensaje 
if ($("body").hasClass("page-asesoria") || $("body").hasClass("page-asesoria_two")) {
    setTimeout(() => {
        if ($("#spaceD").is(":visible")) {
            $("#spaceD").on("change", () => {
                const sel_op = $("#spaceD").val();
                switch (sel_op) {
                    case 'Airbnb':
                        $('#bannerForm').attr('class', 'airbnb');
                        break;
                    case 'Casas muestra':
                        $('#bannerForm').attr('class', 'casas-m');
                        break;
                    case 'Cocina':
                        $('#bannerForm').attr('class', 'cocina');
                        break;
                    case 'Hogar particular':
                        $('#bannerForm').attr('class', 'hogar');
                        break;
                    case 'Negocio':
                        $('#bannerForm').attr('class', 'negocio');
                        break;
                    case 'Oficinas':
                        $('#bannerForm').attr('class', 'oficinas');
                        break;
                    default:
                        $('#bannerForm').attr('class', 'espacio');
                        break;
                }

                if ($("#spaceD").val() !== 'Hogar particular' && $("#spaceD").val() !== 'Cocina') {
                    $(".timeDOpt").fadeIn("slow");
                    $(".timeDOpt").css("display", "inline-flex");
                    $("#timeD").attr("required", "required");
                    // $('#bannerForm').removeClass('hogar');
                    // $('#bannerForm').addClass('negocio');
                } else {
                    $(".timeDOpt").fadeOut("slow");
                    $(".timeDOpt").css("display", "none");
                    $("#timeD").removeAttr("required");
                    // $('#bannerForm').removeClass('negocio');
                    // $('#bannerForm').addClass('hogar');
                }
            })
        }
    }, 2300);
}
//Funcíon que envía los correso dependiendo de cual sea el caso 
function senderMail(formT) {
    if (formT == "asesoria") {
        //Obteniendo valores de la asesoría
        let nameD = $("#nameD").val();
        let stateD = $("#stateD").val();
        let emailD = $("#emailD").val();
        let phoneD = $("#phoneD").val();
        let spaceD = $("#spaceD").val();
        let textareaD = $("#textareaD").val();
        textareaD = textareaD.replace(new RegExp("\n", "g"), "<br>");
        let timeD = "";
        if (spaceD != "Hogar particular" && spaceD !== 'Cocina') {
            timeD = $("#timeD").val();
        }

        if ((nameD == "" || stateD == "" || emailD == "" || phoneD == "" || spaceD == "" || textareaD == "") || ((spaceD != "Hogar particular" && spaceD != "Cocina") && timeD == "")) {
            $("#txtMessage").html("<label class='error'>Completa los campos para poder continuar</label>")
        } else {
            //Loader
            $(".dots").fadeIn();
            $(".submitForm").fadeOut("slow");
            let shop = window.location.host;
            let business = "";
            //Se genera el asunto y el html del correo y se envía mediante ajax
            let subject = "";
            if (spaceD === 'Hogar particular') {
                subject = 'Asesoría para el hogar';
            } else if (spaceD === 'Cocina') {
                subject = 'Asesoría para cocina';
            } else {
                business = '<li>Horario: ' + timeD + '</li>';
                subject = "Asesoría para negocio";
            }
            let emailA = "";

            let bodyE =
                `
                    Se recibió una nueva asesoría en el sitio con los siguientes datos: 
                    <ul>
                        <li>Nombre:  ${nameD}  </li > 
                        <li>Estado de la república:  ${stateD}  </li > 
                        <li>Correo electrónico:  ${emailD}  </li > 
                        <li>Teléfono:  ${phoneD}  </li > 
                        <li>Espacio por decorar:  ${spaceD}  </li > 
                        ${business} 
                        <li>Proyecto:   ${textareaD}  </li> 
                    </ul > 
                    <p class="center" > Si puedes ponerte en contacto con el cliente.<br> 
                    ¡Saludos!</p >
                `
                ;

            let content = `
                <div class="mailBody"> 
                    <div class="cardMail">
                        <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center> 
                        <div class="container"> 
                        <h1 class="title">Asesoría de decoración</h1> 
                            ${bodyE}
                        </div> 
                    </div>                        
                </div> 
            `;

            let typeE = "asesoria";
            let form_data = new FormData();
            form_data.append('shop', shop);
            form_data.append('testing', typeE);
            form_data.append('emailA', emailA);
            form_data.append('subject', subject);
            form_data.append('content', content);


            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/send.php',
                method: 'POST',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    console.log(res);
                    if (isJson(res)) {
                        res = $.parseJSON(res);
                        if (res['res'] == 'Ok') {
                            $(".dots").fadeOut();
                            $(".submitForm").fadeIn("slow");

                            //window.location.reload;
                            $("#txtMessage").html("<label class='okMsg'>Mensaje enviado. En breve nos comunicaremos contigo.</label>")
                            $("#formAsesoria")[0].reset();
                        } else {
                            $("#txtMessage").html("<label class='error'>Hubo un problema al enviar la información.</label>")
                        }
                    } else {
                        console.warn(res);
                    }


                }
            });
        }

    } else if (formT == "sendMesa" && $("#createErr span").html() != 'Solo puedes crear una mesa de regalos a la vez') {
        $('#loaderAAAGift').css('visibility', 'visible');
        //Mismo caso que el anterior pero para envíar la creacion de la mesa
        let form_data = new FormData();
        let direc = $('#shipping_address').val();
        let city = $('#shipping_city').val();
        let state = $('#shipping_state').val();

        const obj = JSON.parse(states);
        let key = '';
        for (let c = 0; c < obj.states.length; c++) {
            if (obj.states[c].nombre === state) {
                key = obj.states[c].clave;
            }
        }

        let cp = $("#shipping_zip").val();
        let address = `${direc}, ${cp}, ${city}, ${state}.`
        let phone = $('#phone').val();

        let bodyE = `
            <ul> 
                <li><strong>Evento: </strong>  ${$("#registry_title").val()}  </li> 
                <li><strong>Fecha: </strong>  ${$("#event_date").val()}  </li> 
                <li><strong>Tipo de evento: </strong>  ${$("#event_type").val()}  </li> 
                <li><strong>Dirección: </strong>  ${address}  </li> 
                <li><strong>Correo electrónico: </strong>  ${$("#email").val()}  </li> 
            </ul>`;

        let contentC = `
            <div class="mailBody">
                <div class="cardMail"> 
                    <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center> 
                    <div class="container"> 
                        <h1 class="title">Mesa de regalos creada</h1> 
                        <p class="center">
                            Se ha creado exitosamente tu mesa de regalos. Recuerda revisar que todo este correcto 
                            <a href="https://cantia.com.mx/apps/giftregistry">aquí</a>.<br>
                            No olvides agregar tus monederos digitales a tu lista de regalos.<br>
                            Gracias por crear tu mesa con nosotros<br>
                            <strong>¡Nos encanta formar parte de tu día a día!.</strong>
                        </p>
                    </div> 
                </div> 
            </div> 
        `;
        let contentA = `
            <div class="mailBody">
                <div class="cardMail"> 
                    <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center> 
                    <div class="container"> 
                        <h1 class="title">Creación de mesa de regalos</h1> 
                        ${bodyE}
                    </div> 
                </div> 
            </div> 
        `;

        let creadoPor = '';
        $.get('https://www.cloudflare.com/cdn-cgi/trace', function (data) {
            //Convert key-value pairs to JSON
            //https://stackoverflow.com/a/39284735/452587
            data = data.trim().split('\n').reduce(function (obj, pair) {
                pair = pair.split('=');
                return obj[pair[0]] = pair[1], obj;
            }, {});
            if (data['ip'] == '187.189.192.106' ||
                data['ip'] == '187.190.171.210' ||
                data['ip'] == '189.181.4.29') {
                creadoPor = "colaborador";
            } else {
                creadoPor = 'cliente';
            }
            form_data = new FormData();//
            form_data.append('eventName', $("#registry_title").val());
            form_data.append('eventDate', $("#event_date").val());
            form_data.append('direc', direc);
            form_data.append('phone', phone);
            form_data.append('cp', cp);
            form_data.append('city', city);
            form_data.append('state', state);
            form_data.append('key', key);
            form_data.append('emailDate', $("#email").val());
            form_data.append('contentA', contentA);
            form_data.append('contentC', contentC);
            let shop = window.location.host;
            form_data.append('shop', shop);
            form_data.append('idCustomer', idCustomer);
            form_data.append('creadoPor', creadoPor);
            form_data.append('nameCustomer', $('#registrant_f_name').val());
            form_data.append('lastNameCustomer', $('#registrant_l_name').val());
            form_data.append('contact_name', $('#contact_name').val());
            form_data.append('contact_phone', $('#contact_phone').val());

            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/sendMesa.php',
                method: 'POST',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    if (isJson(res)) {
                        res = $.parseJSON(res);
                        console.log(res);
                        if (res['res'] == 'Mesa creada con exito') {

                            Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                text: 'Tu mesa ha sido creada',
                                showConfirmButton: false,
                                timer: 2000
                            })
                            //Seteando valor de fecha de evento valido para la aplicación AAA-GR
                            $("#event_date").val($("#event_date").val().replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$2/$1/$3"));
                            $(".aaa_create_registry").click();

                            setTimeout(() => {
                                //window.location.reload();
                            }, 1000);
                        } else {
                            Swal.fire({
                                position: 'top-end',
                                icon: 'warning',
                                text: 'Hubo un error al crear tu mesa, por favor comunícate con nosotros',
                                showConfirmButton: false,
                                timer: 2000
                            })
                        }
                    } else {
                        console.warn(res)
                    }


                },
                complete: function () {
                    setTimeout(() => {
                        $("#loaderAAAGift").css('visibility', 'hidden');
                    }, 1000);
                }
            });
        });


    } else if (formT == "sendEvent") {
        $('#loaderModal').fadeIn();
        $('#loaderModal').css('display', 'block')
        $('#loaderModal').css('visibility', 'visible');

        //Igual que el caso anterior para solicitud de cerre de mesa para que el administror lo sepa 
        //y se habilite el boton de solicitud en el dashboard del admin
        let eventType = $.trim($("td.order1").text());
        let file_prin = $('#compMesa').prop('files')[0];

        let file_dataTwo = "";
        if (eventType === 'Boda') {
            file_dataTwo = $('#ineDos').prop('files')[0];
        }
        let idMesa = $.trim($(".aaa-user.order3").text().replace("ID:\n", ""));
        let form_data = new FormData();
        let bodyE = `
            <ul>
                <li><strong>Mesa: </strong> ${idMesa} </li>
                <li><strong>Fecha: </strong> ${$('#date_evtemp').text()} </li>
                <li><strong>Tipo de evento: </strong> ${$("td.order1").text()} </li>
            </ul>
        `;
        let content = `
            <div class="mailBody"> 
                <div class="cardMail"> 
                    <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center> 
                    <div class="container"> 
                        <h1 class="title">Solicitud de cierre de mesa de regalos</h1> 
                        <p>Se solicita el cierre de la mesa con la siguiente información: </p> 
                        ${bodyE}
                        <br><a href="https://mesaregaloscantia-dot-mx-vianney-001.uc.r.appspot.com/" target="_blank">Revisar información</a> 
                    </div> 
                </div> 
            </div> 
        `;

        let bodyClient = `
            <div class="mailBody">
                <div class="cardMail"> 
                    <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center>
                    <div class="container">
                        <h1 class="title">Solicitud de cierre de mesa de regalos</h1>
                        <p class="text center">
                            Se ha solicitado el cierre de tu mesa #${idMesa} <br>De uno a dos días habiles revisaremos el cierre de tu mesa y nos estaremos comunicando contigo.<br>
                            <br>
                            Puedes revisar tu estado de cuenta <a href="https://cantia.com.mx/apps/giftregistry/registry/${idMesa}" target="_blank">aquí</a>.
                        </p>
                    </div>
                </div>
            </div>
        `;

        let ineOne = ineTwo = files = '';
        file_prin = $('#compMesa').prop('files')[0];
        ineOne = $('#inePrin').prop('files')[0];

        //idMesa

        form_data = new FormData();
        form_data.append('idMesa', idMesa);
        form_data.append('filePrin', file_prin);
        form_data.append('fPName', `${idMesa}-certificado`);
        form_data.append('file', ineOne);
        form_data.append('fName', `${idMesa}-INE01`);
        form_data.append('content', content);
        form_data.append('bodyClient', bodyClient);
        let shop = window.location.host;
        form_data.append('shop', shop);
        form_data.append('idCustomer', idCustomer);
        form_data.append('emailCustomer', emailCustomer);

        if ($('#placeMonederos').length > 0) {
            form_data.append('placeMonederos', $('#placeMonederos').val());
        } else {
            form_data.append('placeMonederos', '');
        }


        if (eventType == 'Boda') {
            ineTwo = $('#ineDos').prop('files')[0];
            files = ineOne + "," + ineTwo;
            form_data.append('fileTwo', file_dataTwo);



            form_data.append('fileTwo', ineTwo);
            form_data.append('fTName', `${idMesa}-INE02`);
            form_data.append('typeEvent', 'boda');//


            //Se envían los documentos al administrador para ser revisados pero depende si es de mesa envía 
            //dos ines si no solo una 
            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/closeTable.php',
                method: 'POST',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    console.log(res);
                    if (isJson(res)) {
                        res = $.parseJSON(res);

                        if (res['res'] == 'Mensajes enviados') {
                            $("#msgModalOk").html('Mensaje envíado.');
                            $("#msgModalOk").fadeIn();
                            Swal.fire({
                                icon: 'success',
                                title: 'Solicitud enviada',
                                showConfirmButton: false,
                                timer: 1000
                            })
                            setTimeout(() => {
                                window.location.href = "https://cantia.com.mx/apps/giftregistry/registry/" + idMesa;
                            }, 1200);
                        } else {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Hubo un error al enviar tu información, inténtalo más tarde',
                                showConfirmButton: false,
                                timer: 1000
                            })
                        }
                    } else {
                        console.warn(res)
                    }

                },
                complete: function () {
                    $('#loaderModal').fadeOut();
                    $('#loaderModal').css('visibility', 'hidden');
                }
            });
        } else {
            form_data.append('typeEvent', 'otro');//
            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/closeTable.php',
                method: 'POST',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    if (isJson(res)) {
                        res = $.parseJSON(res);
                        if (res['res'] == 'Mensajes enviados') {
                            $("#msgModalOk").html('Mensaje envíado.');
                            $("#msgModalOk").fadeIn();
                            Swal.fire({
                                icon: 'success',
                                title: 'Solicitud enviada',
                                showConfirmButton: false,
                                timer: 1000
                            })
                            setTimeout(() => {
                                window.location.href = "https://cantia.com.mx/apps/giftregistry/registry/" + idMesa;
                            }, 1200);
                        } else {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Hubo un error al enviar tu información, inténtalo más tarde',
                                showConfirmButton: false,
                                timer: 2000
                            })
                        }
                    } else {
                        console.warn(res);
                    }

                },
                complete: function () {
                    $('#loaderModal').fadeOut();
                    $('#loaderModal').css('visibility', 'hidden');
                }
            });
        }
    } else if (formT == "sendEventAdm") {//compMesa
        $('#loaderModal').fadeIn();
        $('#loaderModal').css('display', 'block')
        $('#loaderModal').css('visibility', 'visible');
        let placeMonedero = '';
        if ($('#selPlaceMonederos').length > 0) {
            placeMonedero = $('#selPlaceMonederos').val();
        }


        //Se envía correo cuando la mesa se ha cerrado 
        let eventType = $("#evTyp").text();
        let file_prin = $('#compMesa').prop('files')[0];

        let file_dataTwo = "";
        if (eventType === 'Boda') {
            file_dataTwo = $('#ineDos').prop('files')[0];
        }
        const idMesa = $("#idMesaCh").val();
        let form_data = new FormData();
        let bodyE = `
            <ul>
                <li><strong>Mesa: </strong> ${idMesa} </li>
                <li><strong>Fecha: </strong> ${$("#fechaE").text()} </li>
                <li><strong>Tipo de evento: </strong> ${eventType} </li>
            </ul>
        `;
        let content = `
                <div class="mailBody"> 
                    <div class="cardMail"> 
                        <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center> 
                        <div class="container"> 
                        <h1 class="title">Cierre de mesa de regalos</h1> 
                            ${bodyE} 
        `;

        let bodyClient = `
                <div class="mailBody">
                    <div class="cardMail"> 
                        <center><img class="" style="margin-bottom: 20px; width:250px;" src="https://cdn.shopify.com/s/files/1/1292/2935/files/LOGO_cantia_change.png?v=1643318474"/></center>
                        <div class="container">
                            <h1 class="title">Cierre de mesa </h1>                            
        `;

        let ineOne = ineTwo = files = '';
        file_prin = $('#compMesa').prop('files')[0];
        ineOne = $('#inePrin').prop('files')[0];

        //idMesa

        let ifMonederoTd = $('#ifMonedero').text();
        let totalMesa = $.trim($('#totalMesa').text().replace('$', '').replaceAll(',', ''));
        let prlId = $.trim($('#prlMesa').text().replace('$', '').replaceAll(',', ''));
        let totalMone = getBonTotal(ifMonederoTd, totalMesa, prlId);
        form_data = new FormData();
        form_data.append('idMesa', idMesa);
        form_data.append('filePrin', file_prin);
        form_data.append('fPName', `${idMesa}-certificado`);
        form_data.append('file', ineOne);
        form_data.append('fName', `${idMesa}-INE01`);
        form_data.append('content', content);
        form_data.append('bodyClient', bodyClient);
        let shop = window.location.host;
        form_data.append('shop', shop);
        form_data.append('adminId', idCustomer);
        form_data.append('adminEmail', emailCustomer);//ifMonedero
        form_data.append('total', totalMesa);
        form_data.append('totalMone', totalMone);
        form_data.append('boni', parseFloat($.trim($('#boniId').text().replace('$', ''))));

        form_data.append('placeMonedero', placeMonedero);


        if (eventType == 'Boda') {
            ineTwo = $('#ineDos').prop('files')[0];
            files = ineOne + "," + ineTwo;

            form_data.append('fileTwo', file_dataTwo);

            form_data.append('fileTwo', ineTwo);
            form_data.append('fTName', `${idMesa}-INE02`);
            form_data.append('typeEvent', 'boda');//


            //Cierre de mesa además del envío del correo para el propietario de la mesa 
            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/closeTableAdm.php',
                method: 'POST',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    if (isJson(res)) {
                        res = $.parseJSON(res);
                        console.log(res);
                        if (res['res'] == "Mensaje enviado") {
                            $("#msgModalOk").html('Mensaje envíado.');
                            $("#msgModalOk").fadeIn();
                            if (res.code != '') {
                                if (placeMonedero != 'Página web') {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Mesa cerrada',
                                        html: `
                                        <p>
                                            Monedero electrónico en ${placeMonedero}
                                        </p>
                                        <div class="tooltipCpyCantia">
                                            <strong>${res['code']}</strong>
                                            <span class="tooltipCpyCantiaText" id='cpyMnlBnf'>Copiado</span>
                                            <i onclick='cpytxt("#cpyMnlBnf","${res['code']}")' class="fa-regular fa-copy"></i>
                                        </div> 
                                        
                                    `,
                                        showConfirmButton: true,
                                        confirmButtonColor: '#e84e0f'
                                    }).then(() => {
                                        //Creando tabla de pendientes y tabla de entregados
                                        getPendients(idMesa, 'cls');
                                    })
                                } else {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Mesa cerrada',
                                        html: `
                                        <p>
                                            Cúpon digital ${placeMonedero}
                                        </p>
                                        <div class="tooltipCpyCantia">
                                            <strong>${res['code']}</strong>
                                            <span class="tooltipCpyCantiaText" id='cpyMnlBnf'>Copiado</span>
                                            <i onclick='cpytxt("#cpyMnlBnf","${res['code']}")' class="fa-regular fa-copy"></i>
                                        </div> 
                                        
                                    `,
                                        showConfirmButton: true,
                                        confirmButtonColor: '#e84e0f'
                                    }).then(() => {
                                        getPendients(idMesa, 'cls');
                                    })
                                }
                            } else {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Mesa cerrada',
                                    showConfirmButton: true,
                                    confirmButtonColor: '#e84e0f'
                                }).then(() => {
                                    //Creando tabla de pendientes y tabla de entregados
                                    getPendients(idMesa, 'cls');
                                })
                            }




                        } else if (res['res'] == 'Id y email vacios') {
                            closeModal();
                            Swal.fire({
                                position: 'top-end',
                                icon: 'warning',
                                title: 'Solicita al cliente que entre a su mesa para poder registrar su correo e id',
                                showConfirmButton: false,
                                timer: 1500
                            });
                        } else if (res['res'] == 'No exist') {

                            Swal.fire({
                                icon: 'error',
                                title: 'No se puede cerrar esta mesa',
                                text: 'La mesa no tiene asignado un monedero y debería tener un monedero asignado ',
                                showConfirmButton: true,
                                confirmButtonColor: '#e84e0f',
                            })

                        }
                    } else {
                        console.warn(res);
                    }

                },
                complete: function () {
                    $('#loaderModal').fadeOut();
                    $('#loaderModal').css('visibility', 'hidden');
                }
            });
        } else {
            form_data.append('typeEvent', 'otro');//

            $.ajax({
                url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/closeTableAdm.php',
                method: 'POST',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                error: function (request, error) {
                    console.error(arguments);
                    console.error(" Can't do because: " + error);
                },
                success: function (res) {
                    if (isJson(res)) {
                        res = $.parseJSON(res);
                        console.log(res);
                        if (res['res'] == "Mensaje enviado") {
                            $("#msgModalOk").html('Mensaje envíado.');
                            $("#msgModalOk").fadeIn();
                            if (placeMonedero != 'Página web') {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Mesa cerrada',
                                    html: `
                                            <p>
                                                Monedero electrónico en ${placeMonedero}
                                            </p>
                                            <div class="tooltipCpyCantia">
                                                <strong>${res['code']}</strong>
                                                <span class="tooltipCpyCantiaText" id='cpyMnlBnf'>Copiado</span>
                                                <i onclick='cpytxt("#cpyMnlBnf","${res['code']}")' class="fa-regular fa-copy"></i>
                                            </div> 
                                            
                                        `,
                                    showConfirmButton: true,
                                    confirmButtonColor: '#e84e0f'
                                }).then(() => {
                                    getPendients(idMesa, 'cls');
                                })
                            } else {
                                if (res.code != '') {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Mesa cerrada',
                                        html: `
                                                <p>
                                                    Cúpon digital ${placeMonedero}
                                                </p>
                                                <div class="tooltipCpyCantia">
                                                    <strong>${res['code']}</strong>
                                                    <span class="tooltipCpyCantiaText" id='cpyMnlBnf'>Copiado</span>
                                                    <i onclick='cpytxt("#cpyMnlBnf","${res['code']}")' class="fa-regular fa-copy"></i>
                                                </div> 
                                                
                                            `,
                                        showConfirmButton: true,
                                        confirmButtonColor: '#e84e0f'
                                    }).then(() => {
                                        if (ifMonederoTd === 'No quiero el monedero electrónico') {
                                            //Creando tabla de pendientes y tabla de entregados
                                            getPendients(idMesaDB, 'cls');
                                        }
                                    })
                                } else {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Mesa cerrada',
                                        showConfirmButton: true,
                                        confirmButtonColor: '#e84e0f'
                                    }).then(() => {
                                        if (ifMonederoTd === 'No quiero el monedero electrónico') {
                                            //Creando tabla de pendientes y tabla de entregados
                                            getPendients(idMesaDB, 'cls');
                                        }
                                    })
                                }

                            }


                        } else if (res['res'] == 'Id y email vacios') {
                            closeModal();
                            Swal.fire({
                                position: 'top-end',
                                icon: 'warning',
                                title: 'Solicita al cliente que entre a su mesa para poder registrar su correo e id',
                                showConfirmButton: false,
                                timer: 1500
                            });
                        } else if (res['res'] == 'No exist') {

                            const moneTienda = parseFloat($.trim($('#boniId').text().replace('$', ''))) + totalMone;
                            Swal.fire({
                                icon: 'error',
                                title: 'No se puede cerrar esta mesa',
                                text: 'La mesa no tiene asignado un monedero y debería tener un monedero asignado',
                                showConfirmButton: true,
                                confirmButtonColor: '#e84e0f',
                            })

                        }
                    } else {
                        console.warn(res);
                    }
                },
                complete: function () {
                    $('#loaderModal').fadeOut();
                    $('#loaderModal').css('visibility', 'hidden');
                }
            });
        }
    }
}
//Función que envía correos de forma por
function sendDefaultMail(formData) {
    $.ajax({
        url: 'https://sendermail-dot-mx-vianney-001.uc.r.appspot.com/admin/send.php',
        method: 'POST',
        data: formData,
        contentType: false,
        cache: false,
        processData: false,
        headers: {
            "accept": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        error: function (request, error) {
            console.error(arguments);
            console.error(" Can't do because: " + error);
        },
        success: function (res) {
            console.log(res);
        }
    });
}



function getBonTotal(ifMonedero, total, prl) {
    let totalMesa = parseFloat(total);
    //if (ifMonedero == 'Si quiero el monedero electrónico') {
    totalMesa -= parseFloat(prl);
    //} 
    return totalMesa
}